import classNames from "classnames"

import { Paragraph1, Title2 } from "@bounce/design-system"
import type { Nullable } from "@bounce/util"

import type { PNImageProps } from "../../PNImage/PNImage"
import { PNImage } from "../../PNImage/PNImage"

export type TestimonialLogoListProps = {
  items: PNImageProps[]
  title?: Nullable<string>
  subtitle?: Nullable<string>
  className?: string
}

export const TestimonialLogoList = ({ title, subtitle, items, className }: TestimonialLogoListProps) => (
  <section className={classNames("relative mx-auto flex w-full max-w-screen-xl flex-col px-6", className)}>
    <Title2 className="text-black">{title}</Title2>
    {!!subtitle && <Paragraph1 className="mt-2 text-neutral-800 md:mt-2.5 xl:mt-3">{subtitle}</Paragraph1>}
    <div className="mt-14 flex max-w-screen-xl flex-wrap justify-start gap-8">
      {items.map((props, i) => (
        <PNImage
          {...props}
          unoptimized
          imgixParams={{ h: 128, fit: "max" }}
          loading="lazy"
          className="w-auto object-contain"
          key={`testimonial_logo_${i}`}
        />
      ))}
    </div>
  </section>
)
